/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Token } from './Token';
import {
    TokenFromJSON,
    TokenFromJSONTyped,
    TokenToJSON,
    TokenToJSONTyped,
} from './Token';

/**
 * 
 * @export
 * @interface AdminLoginResponse
 */
export interface AdminLoginResponse {
    /**
     * 
     * @type {Token}
     * @memberof AdminLoginResponse
     */
    token: Token;
}

/**
 * Check if a given object implements the AdminLoginResponse interface.
 */
export function instanceOfAdminLoginResponse(value: object): value is AdminLoginResponse {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function AdminLoginResponseFromJSON(json: any): AdminLoginResponse {
    return AdminLoginResponseFromJSONTyped(json, false);
}

export function AdminLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminLoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token': TokenFromJSON(json['token']),
    };
}

export function AdminLoginResponseToJSON(json: any): AdminLoginResponse {
    return AdminLoginResponseToJSONTyped(json, false);
}

export function AdminLoginResponseToJSONTyped(value?: AdminLoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': TokenToJSON(value['token']),
    };
}

